<template>
  <div class="step-c">
    <div class="alert alert-danger" v-if="getphone_number === ''">
        {{ $t("phone_numberError") }}
      </div>
    <div class="row no-gutters">
      <div class="myfield col-2">
        <input
          type="text"
          id="country_code"
          v-model="country_code"
          :placeholder="$t('country_code')"
          class="disable text-muted"
        />
        <label for="country_code">{{ $t("country_code") }}</label>
      </div>
      <div class="myfield col">
        <input
          type="text"
          id="phone_number"
          v-model="phone_number"
          :placeholder="$t('phone_number')"
          @keyup.enter="trySubmit"
        />
        <label for="phone_number">{{ $t("phone_number") }}</label>
      </div>
    </div>
    <div class="myfield">
      <div class="alert alert-danger" v-if="getPassword === ''">
        {{ $t('passwordRequired') }}
      </div>
      <div class="alert alert-danger" v-else-if="getPassword && getPassword.length < 7">
        {{ $t('passwordTooSmall') }}
      </div>
      <input
        type="password"
        id="password"
        v-model="password"
        :placeholder="$t('password')"
        @keyup.enter="trySubmit"
      />
      <label for="password">{{ $t("password") }}</label>
    </div>
    <div class="myfield">
      <div class="alert alert-danger" v-if="getpassword_confirm === ''">
        {{ $t('password_confirmRequired') }}
      </div>
      <div class="alert alert-danger" v-if="getpassword_confirm !== getPassword">
        {{ $t('password_confirmError') }}
      </div>
      <input
        type="password"
        id="password_confirm"
        v-model="password_confirm"
        :placeholder="$t('password_confirm')"
        @keyup.enter="trySubmit"
      />
      <label for="password_confirm">
        {{ $t("password_confirm") }}
      </label>
    </div>
    <div class="flex flex-nowrap">
      <div class="alert alert-danger" v-if="getAgreed === 'false'">
        {{ $t('agreedRequired') }}
      </div>
      <label class="pointer" @click="agreed = !agreed">
        <Checkbox :value.sync="agreed" @change="agreed = !agreed"></Checkbox>
        <small>
          {{ $t("readAndAgree") }}
          <router-link to="/user-agreement" class="lowercase">
            {{ $t("userAgreement") }}
          </router-link>
        </small>
      </label>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/Form/Checkbox'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    Checkbox
  },
  data () {
    return {
      errors: {},
      country_code: '+995',
      phone_number: '',
      password: '',
      password_confirm: '',
      agreed: false
    }
  },
  computed: {
    ...mapGetters({
      try: 'register/try',
      getContryCode: 'register/contryCode',
      getphone_number: 'register/phone_number',
      getPassword: 'register/password',
      getpassword_confirm: 'register/password_confirm',
      getAgreed: 'register/agreed'
    })
  },
  watch: {
    try () {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      query.country_code = this.country_code
      query.phone_number = this.phone_number
      query.agreed = this.agreed
      this.setPassword(this.password)
      this.setpassword_confirm(this.password_confirm)
      this.$router
        .push({
          path: '/register',
          query: query
        })
        .catch(() => {})
    }
  },
  mounted () {
    this.phone_number = this.getphone_number
    this.password = this.getPassword
    this.password_confirm = this.getpassword_confirm
    if (this.getAgreed === 'true') {
      this.agreed = true
    }
  },
  methods: {
    ...mapMutations({
      trySubmit: 'register/trySubmit',
      setPassword: 'register/setPassword',
      setpassword_confirm: 'register/setpassword_confirm'
    })
  }
}
</script>
<style lang="scss">
.step-c {
  .disable {
    pointer-events: none;
  }
}
</style>
<i18n>
{
  "ka": {
    "country_code": "კოდი",
    "phone_number": "ტელეფონის ნომერი",
    "password": "პაროლი",
    "password_confirm": "გაიმეორე პაროლი",
    "male": "მამრობითი",
    "female": "მდედრობითი",
    "userAgreement": "სამომხმარებლო შეთანხმებას",
    "readAndAgree": "წავიკითხე და ვეთანხმები",
    "phone_numberError": "გთხოვთ შეიყოთ ტელეფონის ნომერ",
    "passwordRequired": "გთხოვთ შეიყოთ პაროლი",
    "passwordTooSmall": "შეყვანილი პაროლი მოკლეა",
    "password_confirmRequired": "გთხოვთ შეიყოთ პაროლი განმეორებით",
    "password_confirmError": "შეყვანილი პაროლი არ ემთხვევა განმეორებით შეყვანილს",
    "agreedRequired": "გთხოვთ დაეთანხმოთ სამომხმარებლო შეთანხმებას"
  },
  "en": {
    "country_code": "Code",
    "phone_number": "Phone Number",
    "password": "Password",
    "password_confirm": "Confirm Password",
    "male": "Male",
    "female": "Female",
    "userAgreement": "User Agreement",
    "readAndAgree": "Read and Agree with",
    "phone_numberError": "Please fill phone number",
    "passwordRequired": "Please fill password",
    "passwordTooSmall": "Given password is too small",
    "password_confirmRequired": "Please fill password confirmation",
    "password_confirmError": "Password's value does not match with confirmation",
    "agreedRequired": "Please agree with User Agreement"
  }
}
</i18n>
